/* istanbul ignore file */
const Stripe = require("stripe").default;
const { Mapper, stripeMap } = require("../schema");

class StripeCard {
  constructor({ key }) {
    this.stripe = new Stripe(key, {
      apiVersion: "2020-03-02",
    });
  }

  create(params) {
    return new Promise((resolve, reject) => {
      const { customerId, card } = params;
      const payload = Mapper(card, stripeMap);
      this.stripe.customers
        .create()
        .then(({ id }) => {
          this.createToken(payload)
            .then((response) => {
              this.stripe.customers
                .createSource(id, { source: response.id }, (err, card) => {
                  if (err) reject(err);
                  resolve(card);
                })
                .then((e) => console.log("create", e));
            })
            .catch((error) => {
              reject(error);
            })
            .catch((error) => {
              reject(error);
            })
            .catch((e) => console.log(e));
        })
        .catch((e) => console.log(e));
    })
  }

  createToken(card) {
    return new Promise((resolve, reject) => {
      this.stripe.tokens.create({ card }, (err, token) => {
        if (err) reject(new Error(err));
        resolve(token)
      });
    })
  }
}

module.exports = { StripeCard }
